import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch/index.tsx';

export default {
	get(): boolean {
		return isVisualRefreshEnabled();
	},
};
